/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  SearchExercisesMutationRequest,
  SearchExercisesMutationResponse,
  SearchExercises401,
  SearchExercises403,
} from '../types/SearchExercises.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getSearchExercisesUrl() {
  const res = { method: 'POST', url: `/exercises/search` as const };
  return res;
}

/**
 * @summary Search exercises
 * {@link /exercises/search}
 */
export async function searchExercises(
  data: SearchExercisesMutationRequest,
  config: Partial<RequestConfig<SearchExercisesMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    SearchExercisesMutationResponse,
    ResponseErrorConfig<SearchExercises401 | SearchExercises403>,
    SearchExercisesMutationRequest
  >({ method: 'POST', url: getSearchExercisesUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
